import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["img"]

  toggle() {
    this.imgTarget.classList.toggle("is-zoomed")
  }
}
